import React from "react";
import clsx from 'clsx';


function CompleteSurveyIcon({
  width = 35,
  height = 35,
  color = "#585550",
  xml: space = "preserve",
  className,
  ...props
}) {
  return (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={clsx('w-7 h-7', className)}
      viewBox="0 0 80 80"
    >
      <g>
        <path d="M24,23h44c2.2,0,4,1.8,4,4v4c0,2.2-1.8,4-4,4H24c-2.2,0-4-1.8-4-4v-4C20,24.8,21.8,23,24,23z" />
        <path d="M24,41h25c2.2,0,4,1.8,4,4v4c0,2.2-1.8,4-4,4H24c-2.2,0-4-1.8-4-4v-4C20,42.8,21.8,41,24,41z" />
        <path
          d="M65.9,52c7.7,0,14,6.3,14,14s-6.3,14-14,14s-14-6.3-14-14S58.2,52,65.9,52z M73.8,62.9c0.3-0.3,0.3-1,0-1.3
		l-1.4-1.3c-0.4-0.4-1-0.4-1.4,0l-7.5,8.4l-3.4-3.4c-0.4-0.4-1-0.4-1.4,0l-1.4,1.3c-0.4,0.3-0.4,0.9,0,1.3l4.8,4.7
		c0.4,0.4,0.9,0.6,1.4,0.6c0.6,0,1-0.2,1.4-0.6L73.8,62.9z M24,59h23.2c-0.8,2.3-1.2,4.3-1.2,6c-0.1,2.1,0.1,4.1,0.6,6H24l0,0
		c-2.2,0-4-1.8-4-4v-4l0,0C20,60.8,21.8,59,24,59z"
        />
      </g>
    </svg>
  );
}

export default CompleteSurveyIcon;
